import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["tab", "content"];

  connect() {
    this.currentIndex = 0;
    this.startAutoSwitch();
  }

  startAutoSwitch() {
    this.interval = setInterval(() => {
      this.switchTab();
    }, 4000);
  }

  switchTab() {
    this.currentIndex = (this.currentIndex + 1) % this.tabTargets.length;
    this.showTab(this.currentIndex);
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute("aria-selected", i === index);
      this.contentTargets[i].classList.toggle("hidden", i !== index);
    });
  }

  stopAutoSwitch() {
    clearInterval(this.interval);
  }

  selectTab(event) {
    this.stopAutoSwitch();
    const index = this.tabTargets.indexOf(event.currentTarget);
    this.showTab(index);
  }
}
